import { render, staticRenderFns } from "./StudipTreeNode.vue?vue&type=template&id=5ed51c92&"
import script from "./StudipTreeNode.vue?vue&type=script&lang=js&"
export * from "./StudipTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports